enum UsageType {
  PeePee,
  PooPoo,
}

export default UsageType;
